// sovellusversio, näytetään footerissa ja julkaisuosoite
const version = "Versio 1.61 DEMO"
const julkaisuURL = "https://arviointi.netlify.app"

//POLUT
export const paths = {
    root: "/",
    etusivu: "/etusivu",
    arki: "/arki",
    motivaatio: "/motivaatio",
    osaaminen: "/osaaminen",
    hakutaidot: "/hakutaidot",
    yhteenveto: "/yhteenveto",
    tulos: "/tulos",
    arkeni: "/arkeni",
    motivaationi: "/motivaationi",
    osaamiseni: "/osaamiseni",
    hakutaitoni: "/hakutaitoni",
    tavoitteeni: "/tavoitteeni",
    lopputulos: "/lopputulos"
}

// ETUSIVU YM

// etusivun tekstit
export const frontData = {
    header: "Valmiuteni Duuniin -itsearviointimittari",
    text1: "Mittarin avulla voit arvioida työnhakuvalmiuksiasi sekä tunnistaa vahvuutesi ja kehityskohtasi työllistymisen kannalta merkityksellisillä osa-alueilla.",
    text2: "Voit keskustella erilaisista mittarin käyttömahdollisuuksista yhdessä ohjaajasi kanssa.",
    text3: "Aloita nykyisen tilanteesi arviointi valitsemalla 'Aloita'.",
    button1: "Aloita",
    link1: paths.arki
}

// headerin navigaatiopolun tekstit ja värit
export const headerData = {
    activeNavElementColor: "#F55A1E",
    choicePath: [
        paths.root,
        paths.etusivu,
        paths.arki,
        paths.motivaatio,
        paths.osaaminen,
        paths.hakutaidot,
        paths.yhteenveto,
        paths.tulos
    ],
    adjustPath: [
        paths.arkeni,
        paths.motivaationi,
        paths.osaamiseni,
        paths.hakutaitoni,
        paths.tavoitteeni,
        paths.lopputulos
    ],
    headerLogo: "/images/hankelogo.jpg",
    headerAlt: "Kokemuksella Duunin hankkeen logo ja linkki etusivulle."
}

// footer tekstit
export const footerData = {
    contactName: "KOKEMUKSELLA DUUNIIN! - ESR HANKE",
    contactEmail: "duuniin@karhuseutu.fi",
    footerLinks: {
        karhuseutu: "https://karhuseutu.fi", 
        vipuvoima: "https://rakennerahastot.fi", 
        eu: "https://european-union.europa.eu", 
        pori: "https://www.pori.fi"
    },
    footerImages: {
        karhuseutu: "/images/karhulogo_y.png",
        vipuvoima: "/images/vipulogo_y.png",
        eu: "/images/eulogo_y.png",
        pori: "/images/porilogo_y.png"
    },
    footerAlts: {
        karhuseutu: "Leader karhuseudun logo ja linkki.",
        vipuvoima: "Vipuvoimaa Eu:lta hankkeen logo ja linkki.",
        eu: "Euroopan Unionin logo ja linkki.",
        pori: "Porin kaupungin logo ja linkki."
    },
    versionInfo: version
}

// CHOICES - VALINTAOSIO

export const aChoiceData = {
    id: "A",
    title: "Arkeni",
    options: {
        option5: {
            id: "A",
            colorClass: "choiceColor5",
            text: "vahvistaa voimavaroja",
            hintHeader: "Vahvuustekijäni",
            hintText: "Arkeni sujuu hyvin ja tukee työllistymistäni."
        },
        option4: {
            id: "A",
            colorClass: "choiceColor4",
            text: "ylläpitää voimavaroja",
            hintHeader: "Perusasiat hyvässä kunnossa",
            hintText: "Arjessani on ajoittain haasteita, mutta ne eivät vaikeuta työllistymistäni."
        },
        option3: {
            id: "A",
            colorClass: "choiceColor3",
            text: "koettelee voimavaroja",
            hintHeader: "Jonkin verran parannettavaa",
            hintText: "Arjessani on haaste, joka vaikeuttaa työllistymistäni."
        },
        option2: {
            id: "A",
            colorClass: "choiceColor2",
            text: "kuluttaa voimavaroja",
            hintHeader: "Vielä monia kehityskohteita",
            hintText: "Omassa arjessani on useita työllistymistä vaikeuttavia ongelmia."
        },
        option1: {
            id: "A",
            colorClass: "choiceColor1",
            text: "vie voimavarat",
            hintHeader: "Ei tällä hetkellä tue työllistymistäni",
            hintText: "Arkeni on niin vaikeaa, että se estää työllistymiseni."
        },
    },
    popover: {
        header: "Mitä kaikkea pitikään miettiä arjen osalta...?",
        list: [
            "asuminen", "terveys", "unirytmi", "päihteet", "talous", "harrastukset", "sosiaaliset suhteet"
        ]
    },
    image: "/images/ng_x_arki.webp",
    buttons: {
        confirmOne: "Vahvista valinta"
    },
    links: {
        next: paths.motivaatio
    },
}

export const bChoiceData = {
    id: "B",
    title: "Motivaationi",
    options: {
        option5: {
            id: "B",
            colorClass: "choiceColor5",
            text: "on erinomainen",
            hintHeader: "Vahvuustekijäni",
            hintText: "Olen aktiivinen työnhakija. Motivaationi työllistyä on korkea."
        },
        option4: {
            id: "B",
            colorClass: "choiceColor4",
            text: "on hyvä",
            hintHeader: "Perusasiat hyvässä kunnossa",
            hintText: "Haluan työllistyä ja haen kohtuullisen aktiivisesti töitä."
        },
        option3: {
            id: "B",
            colorClass: "choiceColor3",
            text: "on kohtalainen",
            hintHeader: "Jonkin verran parannettavaa",
            hintText: "Täytän työnhakijan velvoitteeni, se riittää minulle."
        },
        option2: {
            id: "B",
            colorClass: "choiceColor2",
            text: "on vähäinen",
            hintHeader: "Vielä monia kehityskohteita",
            hintText: "En usko työllistymiseeni, enkä ole siksi kovin motivoitunut työnhakuun."
        },
        option1: {
            id: "B",
            colorClass: "choiceColor1",
            text: "on kadonnut",
            hintHeader: "Ei tällä hetkellä tue työllistymistäni",
            hintText: "Työllistymiseni tiellä on esteitä. Minulla ei ole motivatiota pyrkiä työelämään."
        },
    },
    popover: {
        header: "Motivaatio? Ahaa...siis tahto työllistyä!",
        list: [
            "tarpeeni", "tavoitteeni", "haaveeni"
        ]
    },
    image: "/images/ng_x_moti.webp",
    buttons: {
        confirmOne: "Vahvista valinta"
    },
    links: {
        next: paths.osaaminen
    },
}

export const cChoiceData = {
    id: "C",
    title: "Osaamiseni",
    options: {
        option5: {
            id: "C",
            colorClass: "choiceColor5",
            text: "tukee työllistymistä",
            hintHeader: "Vahvuustekijäni",
            hintText: "Minulla on ajantasainen ammatillinen koulutus/osaaminen. Tunnistan osaamiseni ja haluan kehittyä."
        },
        option4: {
            id: "C",
            colorClass: "choiceColor4",
            text: "mahdollistaa työllistymisen",
            hintHeader: "Perusasiat hyvässä kunnossa",
            hintText: "Minulla on ajantasainen ammatillinen koulutus/osaaminen ja jonkin verran alakohtaista työkokemusta."
        },
        option3: {
            id: "C",
            colorClass: "choiceColor3",
            text: "kaipaa vielä päivitystä",
            hintHeader: "Jonkin verran parannettavaa",
            hintText: "Ammatillinen osaamiseni kaipaa pientä jalostusta tai työhistoriani on pirstaleinen."
        },
        option2: {
            id: "C",
            colorClass: "choiceColor2",
            text: "on vielä rakentumassa",
            hintHeader: "Vielä monia kehityskohteita",
            hintText: "Työkokemukseni koostuu kuntouttavasta työtoiminnasta tai työkokeilusta. En välttämättä tiedä mille ammattialalle tähtään."
        },
        option1: {
            id: "C",
            colorClass: "choiceColor1",
            text: "ei riitä työllistymiseen",
            hintHeader: "Ei tällä hetkellä tue työllistymistäni",
            hintText: "Minulla ei ole vielä ammatillista koulutusta, eikä työkokemusta. En tunnista vahvuuksiani."
        },
    },
    popover: {
        header: "Osaaminen...miten sitä nyt lähtisi miettimään?",
        list: [
            "ammattitaito", "koulutus", "kokemus", "halu oppia uutta", "oman osaamisen tunnistaminen"
        ]
    },
    image: "/images/ng_x_osaa.webp",
    buttons: {
        confirmOne: "Vahvista valinta"
    },
    links: {
        next: paths.hakutaidot
    },
}

export const dChoiceData = {
    id: "D",
    title: "Hakutaitoni",
    options: {
        option5: {
            id: "D",
            colorClass: "choiceColor5",
            text: "ovat nykyaikaiset",
            hintHeader: "Vahvuustekijäni",
            hintText: "Käytän useita eri työnhakukanavia ja osaan tuoda esiin vahvuuteni. Muokkaan hakemukset ja CV: n hakukohtaisesti."
        },
        option4: {
            id: "D",
            colorClass: "choiceColor4",
            text: "ovat monipuoliset",
            hintHeader: "Perusasiat hyvässä kunnossa",
            hintText: "Minulla on CV. Käytän enemmän kuin yhtä työnhakukanavaa."
        },
        option3: {
            id: "D",
            colorClass: "choiceColor3",
            text: "ovat kehityskelpoiset",
            hintHeader: "Jonkin verran parannettavaa",
            hintText: "Minulla on vanha CV. Osaan tehdä hakemuksen avoimeen työpaikkaan."
        },
        option2: {
            id: "D",
            colorClass: "choiceColor2",
            text: "ovat ruosteessa",
            hintHeader: "Vielä monia kehityskohteita",
            hintText: "Työnhakutaitoni kaipaavat päivitystä. Minulla ei ole esimerkiksi CV: tä."
        },
        option1: {
            id: "D",
            colorClass: "choiceColor1",
            text: "ovat alkutekijöissään",
            hintHeader: "Ei tällä hetkellä tue työllistymistäni",
            hintText: "Minulla ei ole kokemusta työnhausta. En  tunne työnhakuun liittyviä eri tekijöitä."
        },
    },
    popover: {
        header: "Työnhakutaidot… No, niihin kuuluu ainakin...",
        list: [
            "CV", "hakemukset", "osaamisen markkinointi", "työnhakukanavat"
        ]
    },
    image: "/images/ng_x_taidot.webp",
    buttons: {
        confirmOne: "Vahvista valinta"
    },
    links: {
        next: paths.yhteenveto
    },
}

export const choiceData = {
    titles: {
        arki: "Arkeni",
        motivaatio: "Motivaationi",
        osaaminen: "Osaamiseni",
        hakutaidot: "Hakutaitoni"
    },
    levels: [
        "index", "Ei tällä hetkellä tue työllistymistäni", "Vielä monia kehityskohteita", "Jonkin verran parannettavaa", "Perusasiat hyvässä kunnossa", "Vahvuustekijäni" 
    ],
    buttons: {
        confirmOne: "Vahvista valinta",
        confirmAll: "Vahvista valinnat",
        moveToSection: "Siirry tarkennuksiin"
    },
    links: {
        next: paths.tulos,
        nextSection: paths.arkeni
    }
}

// ADJUST - TARKENNUSOSIO

export const aAdjustData = {
    id: "A2",
    images: {
        pic1: "/images/arki1y.webp",
        pic2: "/images/arki2y.webp",
        pic3: "/images/arki3y.webp",
        pic4: "/images/arki4y.webp"
    },
    alts: {
        pic1alt: "Uni",
        pic2alt: "Ystävät ja läheiset",
        pic3alt: "Päihteet",
        pic4alt: "Raha"
    },
    label: "Mitkä ovat tällä hetkellä arkeni sujumista tukevat tekijät? Mitä asioita haluan kehittää?",
    links: {
        next: paths.motivaationi
    }  
}

export const bAdjustData = {
    id: "B2",
    images: {
        pic1: "/images/moti1x.webp",
        pic2: "/images/moti2x.webp",
        pic3: "/images/moti3x.webp",
        pic4: "/images/moti4x.webp"
    },
    alts: {
        pic1alt: "Matkustus",
        pic2alt: "Unelmat",
        pic3alt: "Kehittyminen",
        pic4alt: "Harrastukset"
    },
    label: "Mitkä ovat tällä hetkellä motivaatiotani tukevia tekijöitä? Mitä haluan kehittää?",
    links: {
        next: paths.osaamiseni
    }  
}

export const cAdjustData = {
    id: "C2",
    images: {
        pic1: "/images/osaa1x.webp",
        pic2: "/images/osaa2x.webp",
        pic3: "/images/osaa3x.webp",
        pic4: "/images/osaa4x.webp"
    },
    alts: {
        pic1alt: "ATK",
        pic2alt: "Näppäryys",
        pic3alt: "Fysiikka",
        pic4alt: "Käsityötaidot"
    },
    label: "Mitkä ovat tällä hetkellä osaamistani tukevia tekijöitä? Mitä haluan kehittää?",
    links: {
        next: paths.hakutaitoni
    }  
}

export const dAdjustData = {
    id: "D2",
    images: {
        pic1: "/images/taidot1x.webp",
        pic2: "/images/taidot2x.webp",
        pic3: "/images/taidot3x.webp",
        pic4: "/images/taidot4x.webp"
    },
    alts: {
        pic1alt: "CV",
        pic2alt: "Portfolio",
        pic3alt: "Hakuvälinetaidot",
        pic4alt: "Haastattelutaidot"
    },
    label: "Mitkä ovat tällä hetkellä hakutaitojani tukevat tekijät? Mitä haluan kehittää?",
    links: {
        next: paths.tavoitteeni
    }  
}

export const adjustData = {
    buttons: {
        posButton: "Vahvuus",
        negButton: "Haluan kehittää",
        confirmOne: "Valmis",
        confirmAll: "Vahvista valinnat"
    },
    tableHeaders: {
        posHeader: "Vahvuuteni (max 3kpl)",
        negHeader: "Haluan kehittää (max 3kpl)",
        goalsPosHeader: "Vahvuuteni",
        goalsNegHeader: "Haluan kehittää"
    },
    help: {
        header: "Arviointiosiossa tekemäsi valinta:",
        text: "Kirjoita alla olevaan laatikkoon yksi vastaus kerrallaan ja merkitse se vahvuudeksi / kehityskohteeksi.",
        totalInfo: "Alla on listattuna itsearviointimittarilla tunnistamiasi vahvuuksia ja kehityskohteita. Merkitse niistä tärkeimmät itsellesi lähitulevaisuuden kehittämistavoitteiksi klikkaamalla kohteita (yhteensä 5 - 10 kpl). Paina lopuksi valmis-nappia."
    },
    links: {
        toResults: paths.lopputulos,
        toHome: paths.etusivu
    }
}

// tarkennusosion tuloskentän tekstit
export const adjustResults = {
    red: [ "Perusvalmiudet kaipaavat vielä vahvistamista.", "Nykyaikainen työelämä on monimuotoista ja erilaisia mahdollisuuksia tarjoavaa. Työelämään osallistuminen siten, että se ei kuormita meitä liikaa, edellyttää meiltä perusvalmiuksien riittävää tasoa. Jotta työelämästä voisi muodostua pysyvä osa arkea, on tärkeää huolehtia näiden perusvalmiuksien hyvästä kunnosta. Voit mittarin tuloksia tarkastelemalla saada tietoa niistä työelämän kannalta tärkeistä osa-alueista, joihin sinun olisi hyvä kiinnittää huomiota.", "Olet arviointia tehdessä muodostanut itsellesi tavoitteita (lista alla). Yhdessä ohjaajan kanssa voitte niiden pohjalta tehdä suunnitelman, jonka avulla voit edistää valittujen osa-alueiden vahvistumista ja näin myös parantaa omia työllistymisen mahdollisuuksia jatkossa.", "Tsemppiä sinulle - ja muistathan, että voit tehdä arvioinnin myöhemmin uudelleen ja näin seurata edistymistäsi!" ],
    yellow: [ "Sinulla on hyvät edellytykset kehittää valmiuksiasi työelämään.", "Nykyaikainen työelämä on monimuotoista ja erilaisia mahdollisuuksia tarjoavaa. Työelämään osallistuminen siten, että se ei kuormita meitä liikaa, edellyttää meiltä tiettyjen perusvalmiuksien riittävää tasoa. Sinulla näyttäisi tekemäsi arvion perusteella olevan perusvalmiudet kunnossa ja hyvät lähtökohdat kehittää työllistymistä edistäviä tekijöitä.", "Olet arviointia tehdessä muodostanut itsellesi myös tavoitteita (lista alla). Pystyt niiden pohjalta luomaan suunnitelmaa eri tekijöiden vahvistamiseksi ja työllistymismahdollisuuksien parantamiseksi. Voit hyödyntää myös ohjaajasi apua suunnitelmaa tehdessäsi.", "Tsemppiä sinulle - ja muistathan, että voit tehdä arvioinnin myöhemmin uudelleen ja näin seurata edistymistäsi!" ],
    green: [ "Sinulla on hyvät edellytykset työllistyä.", "Nykyaikainen työelämä on monimuotoista ja erilaisia mahdollisuuksia tarjoavaa. Työllistyminen edellyttää meiltä työnhakijoina osaamista, oman osaamisen tunnistamista ja osaamisen esille tuomista haettavan työtehtävän vaatimukset huomioiden. Työelämän muutoksissa mukana pysyminen, omien taitojen kehittäminen ja selkeät päämäärät auttavat työelämään sijoittumisessa. Tahto työllistyä on myös merkittävässä roolissa työllistymisen kannalta.", "Tekemäsi arvion pohjalta sinulla on hyvät valmiudet edetä työelämään. Olet arviointia tehdessä muodostanut itsellesi myös tavoitteita (lista alla), joiden saavuttamiseksi sinun on hyvä tehdä konkreettinen suunnitelma. Voit hyödyntää ohjaajasi tarjoamaa tukea suunnitelman tekemisessä.", "Tsemppiä sinulle - ja muistathan, että voit tehdä arvioinnin myöhemmin uudelleen ja näin seurata edistymistäsi!" ]
}

// tarkennusosion alertin tekstit
export const alertTexts = {
    selectedAlert: {
        header: "Huom!",
        text: "Suosittelemme valitsemaan vähintään viisi tavoiteitta mutta voit kuitenkin halutessasi jatkaa myös pienemmällä tavoitemäärällä.",
        title: "Vahvista valinnat ja siirry eteenpäin",
        confirmButton: "Vahvista nykyiset valintani"
    },
    returnAlert: {
        header: "Oletko varma?",
        text: "Painamalla 'vahvista', kaikki materiaali tyhjennetään ja palaudut etusivulle.",
        title: "Tyhjennä istunto ja palaa etusivulle",
        returnButton: "Palaa ja tyhjennä",
    },
    feedbackAlert: {
        header: "Huom!",
        text: "Palautteen antaminen ohjaa sinut sivuston ulkopuolle.",
        title: "Siirry antamaan palautetta",
        url: "https://docs.google.com/forms/d/1CLMSn2jlnLa3o0T9FQsDZ9J2EbgskaRVyvBRhaDsfaU/edit#responses",
        feedButton: "Siirry palautesivulle"
    },
    posButton: "Vahvista",
    negButton: "Peruuta"
}

// PDF ja kaaviot

// valintaosion radar kaavion tekstit
export const radarTexts = {
    labels: ["Arki", "Motivaatio", "Osaaminen", "Hakutaidot"],
    mainHeader: "Valintani",
}

// pdf nappien tekstit
export const pdfButtons = {
    print: "Tulosta raportti",
    download: "Lataa raportti"
}

export const pdfTexts = {
    mainHeader1: "VALMIUTENI DUUNIIN",
    mainHeader2: "Loppusanat",
    subHeader1: "Itsearvioinnin tulos:",
    subHeader2: "Tavoitteesi",
    linkText: "Itsearviontimittarisi verkossa: ",
    link: julkaisuURL
}